module.exports = __webpack_public_path__ + "img/bg-empty.4f724f36.png";